import { Component } from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';

import { firstValueFrom } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationService } from '../../services/translation.service';

@Component({
    selector: 'app-forgot-password',
    standalone: true,
    imports: [RouterModule, ReactiveFormsModule, TranslateModule],
    templateUrl: './forgot-password.component.html',
    styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent {
    public resetForm!: FormGroup;

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private toaster: ToastrService,
        private authService: AuthService,
        private translationService: TranslationService
    ) {
        this.resetForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]],
        });
    }

    async onSubmit() {
        if (!this.resetForm.valid) {
            return;
        }

        const email = this.resetForm.value.email;

        try {
            await firstValueFrom(this.authService.passwordRecovery(email));

            const successMessage = this.translationService.instant(
                'common.messages.operationSuccess'
            );
            this.toaster.success(successMessage);
            this.router.navigate(['/login']);
        } catch (e) {
            const errorMessage = this.translationService.instant(
                'errors.network.serverError'
            );
            this.toaster.error(errorMessage);
        }
    }
}
